import styled from 'styled-components';
import polish from 'polished';

export const TutorialButtonContainer = styled.button`
  background: transparent;
  color: #e9e9e9;
  border-radius: 50%;
  width: 1.2rem;
  height: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #1e88e5;
    color: white;
    transform: scale(1.1);

    svg path,
    svg line,
    svg circle {
      stroke: white;
    }
  }

  &:active {
    transform: scale(0.95);
  }
`;
